import { render } from "./PrivateHome.vue?vue&type=template&id=803be2fa&scoped=true"
import script from "./PrivateHome.vue?vue&type=script&lang=js"
export * from "./PrivateHome.vue?vue&type=script&lang=js"

import "./PrivateHome.vue?vue&type=style&index=0&id=803be2fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803be2fa"]])

export default __exports__